<template>
  <div class="main-bg">
    <b-row class="custom-row">
      <div class="logo">
      <a href="/">
        <img class="custom-logo" src="../../assets/income.svg" width="120"/>
      </a>
      </div>
      <b-col align-self="center" md="6" sm="12">
        <div class="custom-form float-right">
          <b-form v-if="step === 'credentials'" v-on:submit.prevent="login">
            <div class="register-form">
              <h1 class="register-label">Log in</h1>
              <b-alert show variant="warning" v-if="validationError.password.length || validationError.username.length">
                {{ validationError.username }}{{ validationError.password }}
              </b-alert>
              <b-input-group class="reg-input-field">
                <template #prepend>
                  <b-input-group-text class="show-password">
                    <img :src="getSrc('elements/emailIcon.svg')" alt=""/>
                  </b-input-group-text>
                </template>
                <b-form-input class="reg-input"
                              id="input-username"
                              v-model="authData.username"
                              type="email"
                              :state="validationUsernameState"
                              placeholder="your@example.com"
                              ref="usernameSection"
                              required
                ></b-form-input>
              </b-input-group>

              <b-input-group class="reg-input-field mt-3">
                <template #prepend>
                  <b-input-group-text class="show-password">
                    <img :src="getSrc('elements/passwordIcon.svg')" alt=""/>
                  </b-input-group-text>
                </template>
                <b-form-input
                    class="reg-input"
                    pill
                    id="input-password"
                    :type="openPasswordType?'text':'password'"
                    :state="validationPasswordState"
                    v-model="authData.password"
                    placeholder="your password"
                    ref="passwordSection"
                    required
                ></b-form-input>
                <template #append>
                  <b-input-group-text class="show-password">
                    <img
                        :src="openPasswordType?getSrc('elements/showPassword.svg'):getSrc('elements/hidePassword.svg')"
                        alt=""
                        @click="openPasswordType=!openPasswordType"/>
                  </b-input-group-text>
                </template>
              </b-input-group>
              <b-button
                  class="signup-btn"
                  pill block variant="primary"
                  type="submit"
              >Log in
              </b-button>

              <b-button class="custom-spacing custom-sn-reg" pill block variant="outline-secondary"
                  @click="redirectTo('facebook')">
                <img class="icon" :src="getSrc('media/facebookIcon.svg')" alt=""/>
                <span>Log in with Facebook</span>
              </b-button>
              <b-button class="custom-spacing input-icons custom-sn-reg" pill block variant="outline-secondary"
                  @click="redirectTo('google-oauth2')">
                <img class="icon" :src="getSrc('media/googleIcon.svg')" alt=""/>
                Log in with Google
              </b-button>
              <b-button class="custom-spacing custom-sn-reg" pill block variant="outline-secondary"
                  @click="redirectTo('apple')">
                <img class="icon" :src="getSrc('media/appleIcon.svg')" alt=""/>
                Log in with Apple
              </b-button>
              <span class="already-ha">
              <span>Forgot your password? - </span>
              <router-link to="/reset-password">Reset password</router-link>
              </span>
              <br>
              <span class="already-ha">
              <span>Don`t have an account? - </span>
              <router-link to="/register">Register</router-link>
              </span>
            </div>
          </b-form>
          <div v-else-if="step === 'otp'" class="register-form">
            <h1 class="register-label">Two-factor authentication</h1>
            <p class="already-ha mb-4">Enter the 6-digit code from your authenticator app.</p>

            <b-alert show variant="danger" v-if="mfaError">{{ mfaError }}</b-alert>

            <b-input-group class="reg-input-field">
              <b-form-input
                class="reg-input"
                v-model="otpCode"
                type="text"
                inputmode="numeric"
                maxlength="6"
                placeholder="123456"
                @keyup.enter="submitOtp"
                autofocus
              ></b-form-input>
            </b-input-group>

            <b-button
              class="signup-btn"
              pill block variant="primary"
              :disabled="otpCode.length !== 6 || isMfaSubmitting"
              @click="submitOtp"
            >
              <b-spinner v-if="isMfaSubmitting" small class="mr-1"></b-spinner>
              Verify
            </b-button>

            <div class="already-ha mt-3">
              <a href="#" @click.prevent="switchToRecovery">Use a recovery code instead</a>
            </div>
            <div class="already-ha mt-2">
              <a href="#" @click.prevent="backToCredentials">Cancel</a>
            </div>
          </div>
          <div v-else-if="step === 'recovery'" class="register-form">
            <h1 class="register-label">Recovery code</h1>
            <p class="already-ha mb-4">Enter one of your recovery codes.</p>

            <b-alert show variant="danger" v-if="mfaError">{{ mfaError }}</b-alert>

            <b-input-group class="reg-input-field">
              <b-form-input
                class="reg-input"
                v-model="recoveryCode"
                type="text"
                placeholder="Recovery code"
                @keyup.enter="submitRecoveryCode"
                autofocus
              ></b-form-input>
            </b-input-group>

            <b-button
              class="signup-btn"
              pill block variant="primary"
              :disabled="recoveryCode.length === 0 || isMfaSubmitting"
              @click="submitRecoveryCode"
            >
              <b-spinner v-if="isMfaSubmitting" small class="mr-1"></b-spinner>
              Verify
            </b-button>

            <div class="already-ha mt-3">
              <a href="#" @click.prevent="step = 'otp'; mfaError = ''">Back to authenticator code</a>
            </div>
            <div class="already-ha mt-2">
              <a href="#" @click.prevent="backToCredentials">Cancel</a>
            </div>
          </div>

        </div>
      </b-col>
      <b-col
          md="6" sm="0"
          class="disable-sm right-col"
      >
        <right-column/>
      </b-col>
    </b-row>
    <b-modal
      v-model="showRotatedRecoveryCode"
      title="Save your new recovery code"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <p>Your recovery code has been replaced. Save this new code somewhere safe — it will not be shown again.</p>
      <pre class="p-3 mb-4" style="background: #F5FBFF; border-radius: 8px; font-family: monospace; font-size: 16px;">{{ rotatedRecoveryCode }}</pre>
      <b-button pill block variant="primary" @click="acknowledgeRotatedRecoveryCode">
        I have saved it — continue
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import RightColumn from '../../components/auth/RightColumn'
import imageMixin from '@/mixins/image'
import trackingHelper from '@/helpers/trackingHelper'
import localStorageHelper from '@/helpers/localStorageHelper'

export default {
  components: {RightColumn},
  mixins: [imageMixin],
  data()
  {
    return {
      authData: {
        username: '',
        password: ''
      },
      validationUsernameState: null,
      validationPasswordState: null,
      validationError: {
        username: '',
        password: ''
      },
      openPasswordType: false,
      step: 'credentials',
      mfaToken: '',
      otpCode: '',
      recoveryCode: '',
      mfaError: '',
      rotatedRecoveryCode: '',
      showRotatedRecoveryCode: false,
      pendingLoginResponse: null,
      isMfaSubmitting: false
    }
  },
  mounted()
  {
    this.trackLoginFailStatus()
  },
  methods: {
    redirectTo(provider)
    {
      localStorage.setItem('loginProvider', provider)
      this.$auth.login({target: this.$route.query.to}, provider)
    },
    login()
    {
      if (this.authData.username.length === 0)
      {
        this.blink(this.$refs.usernameSection)
        return false
      }
      if (this.authData.password.length === 0)
      {
        this.blink(this.$refs.passwordSection)
        return false
      }

      this.validationError = {username: '', password: ''}
      this.validationUsernameState = null
      this.validationPasswordState = null

      event.preventDefault()
      axios.post('auth0-login', this.authData).then((response) =>
      {
        if (response.data.success === true)
        {
          localStorageHelper.set('loginProvider', 'manual')
          this.completeLogin(response.data)
        }
        // ── MFA required — switch to OTP step
        else if (response.data.mfa_required === true)
        {
          this.mfaToken = response.data.mfa_token
          this.otpCode = ''
          this.recoveryCode = ''
          this.mfaError = ''
          this.step = 'otp'
        }
        else
        {
          this.validationError = response.data.error
          trackingHelper.pushLoginEvent('login_fail', 'manual', response.data.error.username + response.data.error.password)
          this.validationUsernameState = this.validationError.username.length === 0
          this.validationPasswordState = this.validationError.password.length === 0
        }
      })
    },
    async submitOtp()
    {
      if (this.isMfaSubmitting) return
      this.isMfaSubmitting = true
      this.mfaError = ''
      try {
        const response = await axios.post('auth0-login-mfa', {
          mfa_token: this.mfaToken,
          otp: this.otpCode
        })
        if (response.data.success === true)
        {
          this.completeLogin(response.data)
        }
        else
        {
          this.handleMfaError(response.data.error)
        }
      } finally {
        this.isMfaSubmitting = false
      }
    },
    async submitRecoveryCode()
    {
      if (this.isMfaSubmitting) return
      this.isMfaSubmitting = true
      this.mfaError = ''
      try {
        const response = await axios.post('auth0-login-mfa-recovery', {
          mfa_token: this.mfaToken,
          recovery_code: this.recoveryCode
        })
        if (response.data.success === true)
        {
          // Auth0 may rotate the recovery code — must show it once before proceeding
          if (response.data.recoveryCode)
          {
            this.rotatedRecoveryCode = response.data.recoveryCode
            this.pendingLoginResponse = response.data
            this.showRotatedRecoveryCode = true
          }
          else
          {
            this.completeLogin(response.data)
          }
        }
        else
        {
          this.handleMfaError(response.data.error)
        }
      } finally {
        this.isMfaSubmitting = false
      }
    },
    acknowledgeRotatedRecoveryCode()
    {
      this.showRotatedRecoveryCode = false
      if (this.pendingLoginResponse)
      {
        const pending = this.pendingLoginResponse
        this.pendingLoginResponse = null
        this.rotatedRecoveryCode = ''
        this.completeLogin(pending)
      }
    },
    switchToRecovery()
    {
      this.step = 'recovery'
      this.recoveryCode = ''
      this.mfaError = ''
    },
    backToCredentials()
    {
      this.step = 'credentials'
      this.mfaToken = ''
      this.otpCode = ''
      this.recoveryCode = ''
      this.mfaError = ''
    },
    handleMfaError(error)
    {
      if (!error)
      {
        this.mfaError = 'Verification failed. Please try again.'
        return
      }
      if (error.code === 'expired_token' || error.code === 'too_many_attempts')
      {
        this.backToCredentials()
        this.validationError = {username: error.message, password: ''}
        this.validationUsernameState = false
        return
      }

      this.mfaError = error.message || 'Verification failed. Please try again.'
      this.otpCode = ''
      this.recoveryCode = ''
    },
    completeLogin(data)
    {
      localStorageHelper.set('accessToken', data.accessToken)
      localStorageHelper.set('userData', JSON.stringify(data.userData))

      if (data.userData && data.userData.exp)
      {
        localStorageHelper.set('removeAT', data.userData.exp)
      }

      if (data.refreshToken)
      {
        localStorageHelper.set('refreshToken', data.refreshToken)
      }

      const redirectingTo = localStorageHelper.get('targetUrl') ?? '/account'
      localStorageHelper.set('login_success', redirectingTo)
      window.location.href = redirectingTo
    },
    blink(el)
    {
      el.focus()
      el.$el.classList.add('blink-error')
      setTimeout(() =>
      {
        el.$el.classList.remove('blink-error')
      }, 500)
    },
    trackLoginFailStatus()
    {
      const loginProvider = localStorageHelper.get('loginProvider')
      const loginFail = localStorageHelper.get('login_fail')
      if (loginFail)
      {
        trackingHelper.pushLoginEvent('login_fail', loginProvider, loginFail)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-logo {
  position: absolute;
  top: 2rem;
  left: 5rem;
}

.disable-sm {
  display: flex;
  justify-content: center;
}

@media (max-width: 575px) {
  .custom-logo {
    position: initial;
    margin-left: 1rem !important;
    margin-top: 1rem !important;
    margin-bottom: 2rem !important;
  }
  .disable-sm {
    display: none;
  }
}

.custom-spacing {
  margin-bottom: 10px !important;
}

.icon {
  position: relative;
  float: left;
  min-width: 26px;
  margin-top: 0;
  text-align: left;
}

.apple-color {
  fill: #6c757d;
}

.login-label {
  font-size: 48px;
  font-family: Open Sans !important;
}

.custom-spacing:hover .icon .apple-color {
  fill: white;
}

.custom-row {
  margin: 0;
}

.custom-form {
  margin-right: 5vw !important;
}

@media only screen and (min-width: 1250px) {
  .custom-form {
    min-width: 520px;
  }
}

.right-col {
  background-color: rgba(7, 29, 45, 1);
  padding: 0;
}

.main-bg {
  background-color: #F5FBFF;
}

.register-form {
  max-width: 620px;

  .register-label {
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 87px;
    letter-spacing: 1px;
  }

  .reg-input-field {
    height: 72px;
    background: #E2F3FE;
    border: none;
    border-radius: 15px;

    .reg-input {
      height: 72px;
      background: none;
      border: none;
      box-shadow: none;
      font-size: 20px;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill, {
      -webkit-box-shadow: none !important;
      background-image: none !important;
      background-color: transparent !important;
      color: #000000 !important;
      -webkit-text-fill-color: #000;
    }
  }

  .blink-error {
    color: red !important;
    border: 1px dotted red !important;
    border-radius: 5px;
  }

  .show-password {
    max-height: 72px;
    background: transparent;
    border: none;
  }

  .signup-btn {
    background: #31A6FB;
    height: 72px;
    border: 15px;
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    letter-spacing: 1px;
    color: #F5FBFF;
    margin-bottom: 15px;
    margin-top: 15px;
  }

  .custom-sn-reg {
    height: 48px;
  }

  .custom-sn-reg:hover {
    color: #fff;
    background-color: #31A6FB;
    border-color: #31A6FB;
  }

  .already-ha {
    margin-top: 15px;
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 1px;
  }
}

@media (max-width: 575px) {
  .custom-form {
    float: none !important;
    margin-right: 0 !important;
  }

  .register-form .register-label {
    font-size: 36px;
    line-height: 1.2;
    overflow-wrap: anywhere;
  }
}

@media only screen and (min-width: 576px) and (max-width: 765px) {
  .register-form{
    min-width: 500px;
  }
  .logo {
    height: 110px;
    width: 100%;
  }
}

@media only screen and (min-width: 765px) and (max-height: 800px)  {
  .logo {
    display: none;
  }
}

@media only screen and (min-width: 1765px)  {
  .logo {
    display: block;
  }
}
</style>
